import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { StatusColor } from '@/utils/StatusColor.utility'
import { currencyFormat } from '@/utils/currencyFormat'
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Selection, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { FcMultipleInputs } from 'react-icons/fc'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTradeinContext } from '../hooks/useTradeinContext'

const MultipleReceipt = () => {
  const [data, setData] = useState<{ loading: boolean, openModal: boolean, listMulti: any[] }>({ loading: false, openModal: false, listMulti: [] })
  const [selectedKeys, setSelectedKeys] = useState<Selection>(new Set<number>())
  const { ctx, saveCtx } = useTradeinContext()
  const userState = useSelector((store: IAppStore) => store.user)
  const { id } = useParams()

  const total = data.listMulti === undefined ? 0 : (selectedKeys === 'all') ? data.listMulti.reduce((valorAnterior, valorActual) => { return valorAnterior + valorActual.new_discount_amount }, 0) : data.listMulti.filter((item) => selectedKeys.has(String(item.id))).reduce((valorAnterior, valorActual) => { return valorAnterior + valorActual.new_discount_amount }, 0)

  const allSeries = data.listMulti === undefined ? '' : (selectedKeys === 'all') ? data.listMulti.map(item => item.serie).join('-') : data.listMulti.filter((item) => selectedKeys.has(String(item.id))).map(item => item.serie).join('-')
  console.log('🚀 ~ MultipleReceipt ~ allSeries:', allSeries)

  const receiptDevices = () => {
    setData({ ...data, loading: true })
    webApiService.receiptDevices({ idList: (selectedKeys === 'all') ? data.listMulti.map(item => item.id) : Array.from(selectedKeys).map(item => Number(item)), amount: total, id_user: userState.id, series: allSeries, id_role: userState.id_role, email: userState.email, client_email: ctx.tradein.email, id_seller: ctx.tradein.id_seller, client_name: ctx.tradein.name })
      .then((res) => {
        console.log('🚀 ~ .then ~ res:', res)
        enqueueSnackbar('Estado actualizado a Entregado', { variant: 'success' })
        setData({ ...data, loading: false })
        console.log('data receiptDevices ===>', data)
        saveCtx({ ...ctx, reload: true })
      })
      .catch((error: any) => {
        if (error.status === 500 && error.response.data !== undefined) {
          enqueueSnackbar(error.response.data.message, { variant: 'error' })
          enqueueSnackbar('Recargando pagina', { variant: 'warning' })
          saveCtx({ ...ctx, reload: true })
        } else {
          enqueueSnackbar(error.message, { variant: 'error' })
        }

        setData({ ...data, loading: false })
        console.log('error ==>', error)
      })
  }

  const handleClose = () => {
    setData({ ...data, openModal: false })
    setSelectedKeys(new Set())
  }

  const loadData = () => {
    setData({ ...data, loading: true })
    webApiService.getListMulti({ email: ctx.tradein.email, rut: ctx.tradein.rut, created_at: ctx.tradein.created_at }).then((res: any) => {
      if (res.data === undefined) {
        alert(1)
      }

      setData({ ...data, loading: false, listMulti: res.data ?? [] })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  const openModal = () => {
    setSelectedKeys(new Set([String(id)]))
    setData({ ...data, openModal: true })
  }

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  console.log('setSelectedKeys', selectedKeys)
  return (
    <div hidden={data.listMulti === undefined || data.listMulti.length < 1}>
      <Button
        variant='shadow'
        size='sm'
        style={{ marginLeft: '5px' }}
        endContent={<FcMultipleInputs style={{ fontSize: '15px' }} />}
        onClick={() => { openModal() }}
        isLoading={data.loading}
        className='bg-white border border-black text-black '
      >
        Recepción multiple
      </Button>
      <Modal backdrop='blur' isOpen={data.openModal} onClose={handleClose} size='xl'>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>Recepción múltiple</ModalHeader>
          <ModalBody>
            <Table
              aria-label='Example table with client side sorting'
              bottomContentPlacement='outside'
              selectedKeys={selectedKeys}
              selectionMode='multiple'
              onSelectionChange={setSelectedKeys}
              color='secondary'
            >
              <TableHeader>
                <TableColumn>#</TableColumn>
                <TableColumn>Estado</TableColumn>
                <TableColumn>Dispositivo</TableColumn>
                <TableColumn>Monto</TableColumn>
              </TableHeader>
              <TableBody
                isLoading={data.loading}
                loadingContent={<Spinner label='Loading...' />}
              >
                {
                        data.listMulti.map((item: any) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.id}</TableCell>
                            <TableCell><div className='rounded-full inline text-sm text-white px-2 py-1' style={{ backgroundColor: StatusColor(item.status) }}>{ctx.tradein.status}</div></TableCell>
                            <TableCell>{item.brand + ' ' + item.model + ' ' + item.capacity}</TableCell>
                            <TableCell>{currencyFormat(item.new_discount_amount, 'MX')}</TableCell>
                          </TableRow>
                        ))
                      }
              </TableBody>
            </Table>
            <div className='flex justify-end'>
              <p className='pe-5'>Total: <strong>{currencyFormat(total, 'MX')}</strong></p>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color='danger'
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button color='primary' type='submit' onClick={receiptDevices}>
              Recibir
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  )
}

export default MultipleReceipt
